
import logo from './logo.svg';

import Login from './ALLPages/Login';
import Table from './ALLPages/Data';
import AllRoutes from './AllRoutes/AllRoutes';
function App() {
  return (
    <div   >
<AllRoutes/>
    </div>
  );
}

export default App;
